import {useState, useContext, useEffect} from 'react';
// ** Reactstrap Imports
import { Row, Col, Card, CardBody, Form, Label, Input, Button } from 'reactstrap';
import { useNavigate, useParams } from 'react-router-dom';

import axios from 'axios';
import { toast } from 'react-toastify';

import {ContactContext} from '../context/ContactContext';
import useAuth from '../hooks/useAuth';

const EditContact = () => {
  const {auth} = useAuth();
  const navigate = useNavigate();
  const {id} = useParams();
  // console.log(id)


  const [contactInfo, setContactInfo] = useState({})
  const getData = async () => {
          try {
            const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/contacts/find-contact/${id}`, {
                headers: {
                    'Authorization': 'Bearer ' + auth.accessToken
                }
            })
          
            setContactInfo(res.data);

        } catch (error) {
            toast.error(error.response, {
                className: "error-toast",
                position: toast.POSITION.BOTTOM_RIGHT,
                autoClose: 3000
            })
        }
      }
    

    useEffect(() => {
      getData();
    },[id])
            //  // ** States
   let initialState = contactInfo;

  // console.log(contactInfo)
  // // const {contacts, updateContact} = useContext(ContactContext)

    const handleChange = (event) => {
        const { value, name } = event.target
        setContactInfo(prevValue => {
            return({
                ...prevValue,
                [name]: value
            })
        });
    }
   
    const handleUpdateClick = async (event, id) => {
        event.preventDefault();

        let contactName = contactInfo.contactName;
        let designation = contactInfo.designation;
        let phoneOne = contactInfo.phoneOne;
        let phoneTwo = contactInfo.phoneTwo;
        let emailOne = contactInfo.emailOne;
        let emailTwo = contactInfo.emailTwo;

        const formData = new FormData();
        formData.append('contactName', contactName);
        formData.append('designation', designation);
        formData.append('phoneOne', phoneOne);
        formData.append('phoneTwo', phoneTwo);
        formData.append('emailOne', emailOne);
        formData.append('emailTwo', emailTwo);


        try {
            const res = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/contacts/update-contact/${id}`, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'Bearer ' + auth.accessToken
                }
            })
            toast.success(res.data.message, {
                className: "success-toast",
                autoClose: 3000,
                position: toast.POSITION.BOTTOM_RIGHT
            })
            navigate('/contacts/view')


        } catch (error) {
          error.response.data.message ? toast.error(error.response.data.message, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000
            }) :  toast.error(error.response.data.error, {
              className: "error-toast",
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: 3000
          })
            
        }
    }


    const handleReset = async (event) => {
      event.preventDefault();
      navigate('/contacts/view')
    }
 
  return (
    <div className="container">
      <Row sm="12">
            <h5 className="sec-header">Edit Contact</h5>
        </Row> 
      <Row sm='12'>
        <Card>
            <CardBody>
            
          <Col sm='12' className='mb-2'>
          <Form>
            
            <div className='mb-1'>
              <Label className='form-label' for='title'>
                Contact Name <span className='text-danger'>*</span>
              </Label>
              <Input
                id='name'
                type='text'
                className='me-1'
                name='contactName'
                required={true}
                value={contactInfo.contactName}
                onChange={handleChange}
              
              />

            </div>

            <div className='mb-1'>
              <Label className='form-label' for='title'>
                Designation <span className='text-danger'>*</span>
              </Label>
              <Input
                id='designation'
                type='text'
                className='me-1'
                name='designation'
                required={true}
                value={contactInfo.designation}
                onChange={handleChange}
              />
            </div>

            <div className='mb-1'>
              <Label className='form-label' for='title'>
                Phone <span className='text-danger'>*</span>
              </Label>
              <Input
                id='phone'
                type='text'
                className='me-1'
                name='phoneOne'
                required={true}
                value={contactInfo.phoneOne}
                onChange={handleChange}
              />
            </div>

            <div className='mb-1'>
              <Label className='form-label' for='title'>
                Email <span className='text-danger'>*</span>
              </Label>
              <Input
                id='email'
                type='email'
                className='me-1'
                name='emailOne'
                required={true}
                value={contactInfo.emailOne}
                onChange={handleChange}
              />
            </div>
            <Row className='pt-2'>
              <Col>
              <div className='mb-1'>
                <Button
                  block
                  color="success"
                  type='submit'
                  onClick={event => handleUpdateClick(event, id)}
                >
                  Update
                </Button>
              </div>
          
              </Col>
              <Col>
                <div className='mb-1'>
                  <Button
                    block
                    color="warning"
                    onClick={event => handleReset(event)}
                  >
                    Cancel & Go to List
                  </Button>
                </div>         
              </Col>
            </Row>
          </Form>
            
          </Col>
          </CardBody>
        </Card>
          
      </Row>

    </div>
  );
};

export default EditContact;
